(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["payment-promo-switcher"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.__bnplSwitcherInit) return;
  window.__bnplSwitcherInit = true;

  var CONTENT_MIN_HEIGHT = 16;
  var POLL_MS = 250;
  var KLARNA_WAIT_MS = 8000;

  var KLARNA_SHADOW_CSS = [
    '.container,',
    '[part="osm-badge-container"],',
    '.badge {',
    '  border: none !important;',
    '  box-shadow: none !important;',
    '  outline: none !important;',
    '  padding-left: 0 !important;',
    '  margin-left: 0 !important;',
    '  justify-content: flex-start !important;',
    '}',
    '.container svg,',
    '[part="osm-badge-container"] svg,',
    '.badge svg {',
    '  width: 50px !important;',
    '  height: 20px !important;',
    '}',
    '.text-wrapper {',
    '  margin-left: 10px !important;',
    '  font-size: 14px !important;',
    '}',
    '.link {',
    '  font-size: 14px !important;',
    '  color: #0070ba !important;',
    '  font-weight: 500 !important;',
    '}',
    '@media (max-width: 768px) {',
    '  .container,',
    '  [part="osm-badge-container"],',
    '  .badge {',
    '    padding-left: 3px !important;',
    '    padding-right: 8px !important;',
    '  }',
    '  .container svg,',
    '  [part="osm-badge-container"] svg,',
    '  .badge svg {',
    '    transform: scale(1.3) !important;',
    '    transform-origin: center !important;',
    '  }',
    '}'
  ].join('');

  function refreshKlarna() {
    try {
      if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        window.Klarna.OnsiteMessaging.refresh();
        return;
      }
    } catch (error) {}

    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }

  function styleKlarna(root, attempts) {
    attempts = attempts || 0;
    var el = root.querySelector('klarna-placement');
    if (el && el.shadowRoot && el.dataset.bnplStyled !== 'true') {
      var style = document.createElement('style');
      style.textContent = KLARNA_SHADOW_CSS;
      el.shadowRoot.appendChild(style);
      el.style.setProperty('text-align', 'left', 'important');
      el.dataset.bnplStyled = 'true';
      return;
    }
    if (attempts < 20) {
      setTimeout(function() {
        styleKlarna(root, attempts + 1);
      }, 250);
    }
  }

  function widgetHeight(el) {
    if (!el) return 0;
    if (el.tagName === 'IFRAME') {
      return Math.max(el.offsetHeight || 0, el.getBoundingClientRect().height || 0);
    }

    var height = Math.max(el.offsetHeight || 0, el.scrollHeight || 0);
    if (el.shadowRoot && el.shadowRoot.children.length) {
      Array.prototype.forEach.call(el.shadowRoot.children, function(child) {
        height = Math.max(height, child.scrollHeight || 0, child.offsetHeight || 0);
      });
    }
    Array.prototype.forEach.call(el.children || [], function(child) {
      height = Math.max(height, child.offsetHeight || 0, child.scrollHeight || 0);
    });
    return height;
  }

  function isKlarnaRendered(panel) {
    var el = panel && panel.querySelector('klarna-placement');
    if (!el) return false;
    if (el.hidden) return false;

    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    if (el.getBoundingClientRect().height >= CONTENT_MIN_HEIGHT) return true;

    if (el.shadowRoot) {
      var part = el.shadowRoot.querySelector('[part="osm-message"], [part="osm-container"], .text-wrapper, iframe');
      if (part && widgetHeight(part) >= CONTENT_MIN_HEIGHT) return true;
    }

    var iframe = el.querySelector('iframe');
    return !!(iframe && widgetHeight(iframe) >= CONTENT_MIN_HEIGHT);
  }

  function setProvider(root, provider) {
    var select = root.querySelector('[data-bnpl-select]');
    if (select && select.value !== provider) select.value = provider;

    root.querySelectorAll('[data-bnpl-panel]').forEach(function(panel) {
      var active = panel.getAttribute('data-bnpl-panel') === provider;
      panel.classList.toggle('is-active', active);
    });

    if (provider === 'klarna') {
      refreshKlarna();
      requestAnimationFrame(function() {
        styleKlarna(root);
      });
    }
  }

  function lockPanelHeight(root) {
    if (!root.classList.contains('is-dual')) return;
    var panels = root.querySelector('.bnpl-switcher__panels');
    if (!panels) return;
    var maxHeight = 0;
    root.querySelectorAll('[data-bnpl-panel]').forEach(function(panel) {
      maxHeight = Math.max(maxHeight, panel.scrollHeight, widgetHeight(panel));
    });
    if (maxHeight >= CONTENT_MIN_HEIGHT) {
      var styles = window.getComputedStyle(panels);
      var padding = (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
      var next = Math.ceil(maxHeight + padding) + 'px';
      if (panels.style.minHeight !== next) panels.style.minHeight = next;
    }
  }

  function enterDual(root) {
    root.classList.remove('is-pending', 'is-single', 'is-empty');
    root.classList.add('is-dual');
    root.hidden = false;
    lockPanelHeight(root);
    if (!root._bnplResizeObserver && typeof ResizeObserver !== 'undefined') {
      root._bnplResizeObserver = new ResizeObserver(function() {
        lockPanelHeight(root);
      });
      root.querySelectorAll('[data-bnpl-panel]').forEach(function(panel) {
        root._bnplResizeObserver.observe(panel);
      });
    }
  }

  function enterSingle(root) {
    var panels = root.querySelector('.bnpl-switcher__panels');
    if (panels) panels.style.minHeight = '';
    root.classList.remove('is-pending', 'is-dual', 'is-empty');
    root.classList.add('is-single');
    root.hidden = false;
    setProvider(root, 'paypal');
  }

  function initSwitcher(root) {
    if (root.dataset.bnplInit === 'true') return;
    root.dataset.bnplInit = 'true';
    root.classList.add('is-pending');
    root.classList.remove('is-dual', 'is-single');

    refreshKlarna();
    styleKlarna(root);

    var klarnaPanel = root.querySelector('[data-bnpl-panel="klarna"]');
    var placement = klarnaPanel && klarnaPanel.querySelector('klarna-placement');
    var startedAt = Date.now();
    var done = false;
    var mutationObserver = null;
    var resizeObserver = null;

    function stopWatching() {
      if (mutationObserver) mutationObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
    }

    function sync() {
      if (done) return;

      if (isKlarnaRendered(klarnaPanel)) {
        done = true;
        stopWatching();
        enterDual(root);
        return;
      }

      if (Date.now() - startedAt >= KLARNA_WAIT_MS) {
        done = true;
        stopWatching();
        enterSingle(root);
      }
    }

    if (typeof MutationObserver !== 'undefined' && klarnaPanel) {
      mutationObserver = new MutationObserver(sync);
      mutationObserver.observe(klarnaPanel, { childList: true, subtree: true, attributes: true });
    }

    if (typeof ResizeObserver !== 'undefined' && placement) {
      resizeObserver = new ResizeObserver(sync);
      resizeObserver.observe(placement);
    }

    function poll() {
      if (done) return;
      sync();
      if (!done) setTimeout(poll, POLL_MS);
    }

    poll();
  }

  function initAll() {
    document.querySelectorAll('[data-bnpl-switcher]').forEach(initSwitcher);
  }

  document.addEventListener('change', function(event) {
    var select = event.target.closest('[data-bnpl-select]');
    if (!select) return;
    var root = select.closest('[data-bnpl-switcher]');
    if (!root || !root.classList.contains('is-dual')) return;
    setProvider(root, select.value);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recommended-kit"] && !Shopify.designMode) return;
  try {
    (function() {

    function moneyFormat(cents) {
      var settings = (window.themeVariables && window.themeVariables.settings) || {};
      var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
      format = String(format || ('${' + '{amount}}')).replace(/<[^>]*>/g, '');
      cents = Number(cents) || 0;
      var placeholder = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      if (placeholder.indexOf('no_decimals') !== -1) {
        value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, placeholder.indexOf('comma') !== -1 ? '.' : ',');
      } else if (placeholder.indexOf('comma_separator') !== -1) {
        value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (parts[1] || '00');
      } else if (placeholder.indexOf('space_separator') !== -1) {
        value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + (parts[1] || '00');
      } else {
        value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + (parts[1] || '00');
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    function RecommendedKit(root) {
      this.root = root;
      this.drawer = root.querySelector('[data-rk-drawer]');
      this.openBtn = root.querySelector('[data-rk-open]');
      this.previewImage = this.drawer.querySelector('[data-rk-preview-image]');
      this.previewCopy = this.drawer.querySelector('[data-rk-preview-copy]');
      this.totalEl = this.drawer.querySelector('[data-rk-total]');
      this.atcBtn = this.drawer.querySelector('[data-rk-atc]');
      this.buyBtn = this.drawer.querySelector('[data-rk-buy]');
      this.busy = false;
      this.bind();
      this.syncPreview();
      this.updateTotal();
    }

    RecommendedKit.prototype.bind = function() {
      var self = this;
      if (this.openBtn) {
        this.openBtn.addEventListener('click', function() { self.open(); });
      }
      this.drawer.addEventListener('click', function(event) {
        if (event.target.closest('[data-rk-close]')) {
          if (!self.busy) self.close();
          return;
        }
        if (self.busy) return;
        var qtyWrap = event.target.closest('[data-rk-qty]');
        if (qtyWrap) {
          event.preventDefault();
          event.stopPropagation();
          var qtyBtn = event.target.closest('[data-rk-qty-delta]');
          if (qtyBtn) {
            self.changeQty(qtyBtn.closest('[data-rk-acc]'), Number(qtyBtn.getAttribute('data-rk-qty-delta')));
          }
          return;
        }
        var kit = event.target.closest('[data-rk-kit]');
        if (kit) {
          self.toggleKit(kit);
          return;
        }
        var acc = event.target.closest('[data-rk-acc]');
        if (acc) {
          self.toggleAcc(acc);
        }
      });
      this.drawer.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var acc = event.target.closest('[data-rk-acc]');
        if (acc && event.target === acc) {
          event.preventDefault();
          self.toggleAcc(acc);
        }
      });
      this.atcBtn.addEventListener('click', function(event) {
        event.preventDefault();
        self.addToCart();
      });
      this.buyBtn.addEventListener('click', function(event) {
        event.preventDefault();
        self.buyNow();
      });
      document.addEventListener('keydown', function(event) {
        if ((event.key === 'Escape' || event.keyCode === 27) && self.drawer.classList.contains('is-open') && !self.busy) {
          self.close();
        }
      });
    };

    RecommendedKit.prototype.lockPage = function() {
      if (document.body.dataset.rkScrollLock === 'true') return;
      this.scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.rkScrollLock = 'true';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this.scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    };

    RecommendedKit.prototype.unlockPage = function() {
      if (document.body.dataset.rkScrollLock !== 'true') return;
      document.body.dataset.rkScrollLock = 'false';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, this.scrollY || 0);
    };

    RecommendedKit.prototype.open = function() {
      if (this.drawer.parentElement !== document.body) {
        document.body.appendChild(this.drawer);
      }
      this.drawer.hidden = false;
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
      this.lockPage();
      var drawer = this.drawer;
      requestAnimationFrame(function() {
        drawer.classList.add('is-open');
      });
    };

    RecommendedKit.prototype.close = function() {
      this.drawer.classList.remove('is-open');
      this.drawer.hidden = true;
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'false');
      this.unlockPage();
    };

    RecommendedKit.prototype.resetSelection = function() {
      this.drawer.querySelectorAll('[data-rk-kit]').forEach(function(item, index) {
        var selected = index === 0;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      this.drawer.querySelectorAll('[data-rk-acc]').forEach(function(acc) {
        acc.classList.remove('is-selected');
        acc.setAttribute('aria-pressed', 'false');
        var valueEl = acc.querySelector('[data-rk-qty-value]');
        if (valueEl) valueEl.textContent = '1';
      });
      this.syncPreview();
      this.updateTotal();
    };

    RecommendedKit.prototype.toggleKit = function(kit) {
      var alreadySelected = kit.classList.contains('is-selected');
      this.drawer.querySelectorAll('[data-rk-kit]').forEach(function(item) {
        var selected = !alreadySelected && item === kit;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      this.syncPreview();
      this.updateTotal();
    };

    RecommendedKit.prototype.toggleAcc = function(acc) {
      var selected = !acc.classList.contains('is-selected');
      acc.classList.toggle('is-selected', selected);
      acc.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (selected) {
        var valueEl = acc.querySelector('[data-rk-qty-value]');
        if (valueEl) valueEl.textContent = '1';
      }
      this.updateTotal();
    };

    RecommendedKit.prototype.changeQty = function(acc, delta) {
      if (!acc || !acc.classList.contains('is-selected')) return;
      var valueEl = acc.querySelector('[data-rk-qty-value]');
      var next = Math.max(1, Math.min(99, (parseInt(valueEl.textContent, 10) || 1) + delta));
      valueEl.textContent = String(next);
      this.updateTotal();
    };

    RecommendedKit.prototype.selectedKit = function() {
      return this.drawer.querySelector('[data-rk-kit].is-selected');
    };

    RecommendedKit.prototype.syncPreview = function() {
      var kit = this.selectedKit();
      if (!kit) return;
      var src = kit.getAttribute('data-preview-src') || '';
      var copy = kit.getAttribute('data-copy') || '';
      if (this.previewImage) {
        this.previewImage.src = src;
        this.previewImage.alt = copy;
        this.previewImage.style.display = src ? '' : 'none';
      }
      if (this.previewCopy) this.previewCopy.textContent = copy;
    };

    RecommendedKit.prototype.collectItems = function() {
      var items = [];
      var kit = this.selectedKit();
      if (kit && kit.getAttribute('data-available') === 'true') {
        items.push({
          variantId: String(kit.getAttribute('data-variant-id')),
          quantity: 1,
          price: Number(kit.getAttribute('data-price')) || 0
        });
      }
      this.drawer.querySelectorAll('[data-rk-acc].is-selected').forEach(function(acc) {
        if (acc.getAttribute('data-available') !== 'true') return;
        var qty = parseInt((acc.querySelector('[data-rk-qty-value]') || {}).textContent, 10) || 1;
        items.push({
          variantId: String(acc.getAttribute('data-variant-id')),
          quantity: qty,
          price: Number(acc.getAttribute('data-price')) || 0
        });
      });
      return items;
    };

    RecommendedKit.prototype.updateTotal = function() {
      var total = this.collectItems().reduce(function(sum, item) {
        return sum + item.price * item.quantity;
      }, 0);
      if (this.totalEl) this.totalEl.textContent = moneyFormat(total);
    };

    RecommendedKit.prototype.setBusy = function(busy, activeBtn) {
      this.busy = busy;
      [this.atcBtn, this.buyBtn].forEach(function(btn) {
        if (!btn) return;
        btn.disabled = busy;
        btn.setAttribute('aria-busy', busy && btn === activeBtn ? 'true' : 'false');
      });
    };

    RecommendedKit.prototype.addToCart = async function() {
      if (this.busy) return;
      var items = this.collectItems();
      if (!items.length) return;
      this.setBusy(true, this.atcBtn);
      try {
        var sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));
        var response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: items.map(function(item) {
              return { id: Number(item.variantId), quantity: item.quantity };
            }),
            sections: sectionsToBundle.join(','),
            sections_url: window.location.pathname
          })
        });
        var responseJson = await response.json();
        if (!response.ok) {
          throw new Error(responseJson.description || 'Add to cart failed');
        }
        var cartContent = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function(r) { return r.json(); });
        cartContent.sections = responseJson.sections;
        this.close();
        this.resetSelection();
        document.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson],
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent
          }
        }));
      } catch (error) {
        console.error(error);
      } finally {
        this.setBusy(false);
      }
    };

    RecommendedKit.prototype.buyNow = async function() {
      if (this.busy) return;
      var items = this.collectItems();
      if (!items.length) return;
      if (typeof window.createCartAndCheckout !== 'function') {
        console.error('createCartAndCheckout is not available');
        return;
      }
      this.setBusy(true, this.buyBtn);
      try {
        await window.createCartAndCheckout(items.map(function(item) {
          return { variantId: item.variantId, quantity: item.quantity };
        }));
      } catch (error) {
        console.error(error);
        this.setBusy(false);
      }
    };

    function init() {
      document.querySelectorAll('[data-rk-root]').forEach(function(root) {
        if (root.__rkReady) return;
        if (!root.querySelector('[data-rk-drawer]')) return;
        root.__rkReady = true;
        new RecommendedKit(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
